import { toastError } from '../../../infrastructure/hooks/useToast'
import { createSlice } from '../zustandHelpers'
import { IPlantInfosState, IPlantInfosActions } from './plantInfos.slice.interface'

export const plantInfosSlice = createSlice<IPlantInfosState, IPlantInfosActions>((set: any) => ({
  plantInfosData: null,
  chargeExploitationData: null,
  plantInfosLoading: false,
  plantInfosError: null,

  setPlantInfosData: async (plantInfosData) => {
    set({ plantInfosLoading: true, plantInfosError: null })
    try {
      set({ plantInfosData, plantInfosLoading: false })
    } catch (error) {
      set({
        plantInfosLoading: false,
        plantInfosError: new Error('Error fetching plant info data'),
      })
      toastError('Error fetching plant info data')
    }
  },

  setChargeExploitationData: async (chargeExploitationData) => {
    set({ plantInfosLoading: true, plantInfosError: null })
    try {
      set({ chargeExploitationData, plantInfosLoading: false })
    } catch (error) {
      set({
        plantInfosLoading: false,
        plantInfosError: new Error('Error fetching charge exploitation data'),
      })
      toastError('Error fetching charge exploitation data')
    }
  },

  cleanPlantInfosData: () => {
    set({
      plantInfosData: null,
      chargeExploitationData: null,
      plantInfosError: null,
      plantInfosLoading: false,
    })
  },
  cleanChargeExploitationData: () => {
    set({ chargeExploitationData: null })
  },
}))
